module.exports = __webpack_public_path__ + "img/1960_no.70950176.svg";